import { render } from "./ScheduleBox.vue?vue&type=template&id=a138a580&ts=true"
import script from "./ScheduleBox.vue?vue&type=script&lang=ts"
export * from "./ScheduleBox.vue?vue&type=script&lang=ts"

import "./ScheduleBox.vue?vue&type=style&index=0&id=a138a580&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__